import { Loading3QuartersOutlined } from '@ant-design/icons';
import { faArrowRight, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spin } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function ActionCard({ data, onClick, loading }) {
  return (
    <div
      onClick={onClick}
      className="flex flex-col justify-between h-full gap-6 p-8 transition-all duration-300 bg-white rounded-lg cursor-pointer hover:shadow-xl shadow-bottom"
    >
      {/* icon and header */}
      <div className="flex items-center gap-4">
        <div
          className={`flex items-center justify-center w-12 h-12 bg-blue-100 rounded-lg ${data.bgColor}`}
        >
          <FontAwesomeIcon
            icon={data.icon}
            className={`${data.color} !text-xl`}
          />
        </div>
        <label className="text-[#000000d8] text-xl font-bold">
          {data.label}
        </label>
      </div>

      {/* description */}
      <div>
        <span className="font-medium text-gray-600">{data.description}</span>
      </div>

      {/* counts and arrow button */}
      <div className="flex items-center justify-between">
        {loading ? (
          <Spin indicator={<Loading3QuartersOutlined spin />} size="small" />
        ) : (
          <span className={`text-xs font-semibold ${data.color}`}>
            {data.counts}
          </span>
        )}
        <FontAwesomeIcon
          icon={faArrowRight}
          className=" !text-gray-400 !text-sm"
        />
      </div>
    </div>
  );
}
